<template>
  <Content @back="$router.push('/home')">
    <template v-slot:nav_left>
      <div style="background-color:#4cd964;padding:10px 15px; ">精英训练营报名</div>
    </template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="openAddDialog" v-if="userRole === 'system' || userRole === 'admin'">
        添加精英训练营报名
      </div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box" v-if="userRole === 'system' || userRole === 'admin'">


        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th name"><strong>训练营报名</strong></div>
              <div class="th telNumber"><strong>年龄段</strong></div>
              <div class="th status"><strong>状态</strong></div>
              <div class="th org"><strong>类型</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                        v-for="(item, index) in centerList"
                        :key="index"
                        class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td name" :title="item.enrollName">
                      <p>{{ item.enrollName || '--' }}</p>
                    </div>
                    <div class="td telNumber" :title="`${item.playerAges}`">
                      <p>{{item.playerAges || '--' }}</p>
                    </div>
                    <div class="td status">
                      <p>{{ item.enrollStatus | statusFilter }}</p>
                    </div>
                    <div class="td org">
                      <p>{{ item.enrollType | typeFilter }}</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                        <template v-if="item.enrollStatus === 'Edit' && (userRole === 'system' || userRole === 'admin')">
                          <span class="split">/</span>
                          <span class="item" @click="editCenter(item.uuid)">编辑</span>
                        </template>

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <el-dialog
        :visible.sync="batchAdd"
        width="500px"
        title="选择报名类型"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        custom-class="yioks_alert2"
      >
        <el-form ref="batchInfo" :model="batchInfo" label-width="80px">
          <div style="margin-right: 30px">

            <el-form-item
              label="类型"
              prop="enrollType"
              :rules="[
                      { required: true, message: '请选择报名类型', trigger: 'change' },
                    ]"
            >
              <el-radio-group v-model="batchInfo.enrollType"  class="radio-content">
                <el-radio
                  v-for="item in enrollTypeList"
                  :label="item.value"
                  :key="item.value"
                  :disabled="item.disable"
                  class="radio-item"
                  border
                >{{item.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <div class="btn-wrapper" style="text-align:center">
          <el-button type="primary" @click="toAddTrainCampPlan">添加精英训练营报名</el-button>
        </div>
      </el-dialog>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import trainCamp from '@/api/trainCampEnroll'
import storage from '@/utils/storage'
import person from '@/assets/images/common/person.jpg'
import regions from '@/utils/regions'
import org from '@/api/org'
import { trainCampEnrollStatus,trainCampEnrollType } from '@/utils/yioks_filter'
export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPlayerDialog': () => import('@/components/trainCamp'),
  },
  filters: {
    statusFilter (val) {
      return trainCampEnrollStatus(val)
    },
    typeFilter(val){
      return trainCampEnrollType(val)
    }
  },
  data () {
    return {
      regions,
      userRole : storage.get('userInfo').userRole,
      centerUuid: '',
      selectRegions: regions,
      selectCityList: [],
      enrollTypeList: [{value:"player",label:"球员",disable:false},{value:"coach",label:"教练",disable:true}],
      batchInfo: {
        enrollType:""
      },
      coach: '',
      total: 0,
      page: 0,
      pageSize: 20,
      batchAdd: false,
      empty: false,
      showList: false,
      person,
      loading: true,
      coachUuid: '',
      addbtnLoading: false,
      selectVal: {
        keyWord: '',
        organUuid: '',
        regionUuid:''
      },
      organList: [], // 机构列表
      centerList: [], // 青训中心列表,
      cityList: []
    }
  },
  watch: {
    page () {
      this.changeQuery()
    },
  },
  created () {
    const { page,   keyWord } = this.$route.query
    page && (this.page = Number(page))
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    // this.getCoachAccount()
    this.getCenterList();
  },
  methods: {
    /* 添加 == 弹窗 */
    openAddDialog() {
      this.batchInfo.enrollType = "player"; // 先默认选中球员
      let { enrollType } = this.batchInfo;
      let queryData = {};
      queryData = { enrollType }
      this.$router.push({
        path: "enrollAdd",
        query: queryData,
      });
    },
    goRegionCamp(){
      this.$router.push({
        path: "list",
      });
    },
    toAddTrainCampPlan(){
      let queryData = {};
      let { enrollType } = this.batchInfo;
      queryData = { enrollType }
      this.$refs.batchInfo.validate((valid) => {
        if (valid) {
          this.$router.push({
            path: "enrollAdd",
            query: queryData,
          });
        }
      })
    },
    getCenterList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let req = trainCamp.getCenterListByOrg
      const userRole = storage.get('userInfo').userRole
      if (userRole === 'system' || userRole === 'admin') { req = trainCamp.getCenterListBySystem }
      req({ page: this.page, size: this.pageSize, key: this.selectVal.keyWord, organUuid: this.selectVal.organUuid , regionUuid: this.selectVal.regionUuid}).then((res) => {
        this.loading = false
        let data = res.content
        this.total = res.totalElements
        if (data.length) {
          this.centerList = data
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    editCenter (uuid) {
      let queryData = {};
      queryData = { enrollUuid:uuid }
      this.$router.push({
        path: "enrollAdd",
        query: queryData,
      });
    },
    goInfo (uuid) {
      if (this.userRole === 'system' || this.userRole === 'admin'){
        this.$router.push({
          path: 'trainCampEnrollInfo',
          query: {
            enrollUuid:uuid
          }
        })
      } else{
        this.$router.push({
          path: 'infoToYouthEnroll',
          query: {
            enrollUuid:uuid
          }
        })
      }

    },

    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          keyWord: this.selectVal.keyWord,
          organUuid: this.selectVal.organUuid,
          regionUuid: this.selectVal.regionUuid,
        }
      })
      this.getCenterList()
    },

  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom:15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq{
        width 7%
      }
      .name{
        width 37%
        padding 0 5px
        box-sizing border-box
      }
      .org{
        width: 10%;
      }
      .telNumber{
        width:20%;
        padding 0 5px
        box-sizing border-box
      }
      .status{
        width 12.5%
      }
      .opt{
        width: 12.5%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
    .radio-content {
      width 560px
      text-indent: 10px
      .radio-item {
        margin-bottom 10px
      }
    }
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>

